import type { JSX } from 'react'

export const GeoblockIcon = (): JSX.Element => (
  <use href='#geoblockIcon' height='100%' width='100%' />
)
